import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  data: {},
  loading: false,
})

const { Types, Creators } = createActions({
  getServiceAvailability: null,

  setServiceAvailability: ['data'],

  setSingleServiceZone: ['payload'],
  removeSingleServiceZone: ['payload']
})

export const getServiceAvailabilityReducer = state => state.set('loading', true)

export const setServiceAvailabilityReducer = (state, { data }) => state
  .set('data', data)
  .set('loading', false)

export const setSingleServiceZoneReducer = (state, { payload }) =>
  state.setIn(['data', payload.id], payload.data)

export const removeSingleServiceZoneReducer = (state, { payload }) =>
  state.setIn(['data'], state.data.without(payload.id))

export const ServiceAvailabilityReducer = createReducer(INITIAL_STATE, {
  [Types.SET_SERVICE_AVAILABILITY]: setServiceAvailabilityReducer,
  [Types.SET_SINGLE_SERVICE_ZONE]: setSingleServiceZoneReducer,
  [Types.REMOVE_SINGLE_SERVICE_ZONE]: removeSingleServiceZoneReducer,
})

export const ServiceAvailabilityTypes = Types
export default Creators


// WEBPACK FOOTER //
// ./src/reducers/serviceAvailabilityReducer.js